import { CardElement } from "@stripe/react-stripe-js";
import axios from "axios";
import React, { useEffect, useState } from "react";

const cardElementStyles = {
  base: {
    fontSize: "16px",
    color: "#32325d",
    fontFamily: "Arial, sans-serif",
    "::placeholder": {
      color: "#aab7c4",
    },
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a",
  },
};

const PaymentMethodForm = ({
  handleSubmit,
  setuserDetails,
  userDetails,
  cardError,
  loader,
}) => {
  const [myCountry, setMyCountry] = useState({
    country: "Singapore",
    countryCode: "SG",
  });

  // Static list of top 100 countries
  const countries = [
    { countryName: "Singapore", countryCode: "SG" },
    { countryName: "Bangladesh", countryCode: "BD" },
    { countryName: "India", countryCode: "IN" },
    { countryName: "Malaysia", countryCode: "MY" },
    { countryName: "Philippines", countryCode: "PH" },
    { countryName: "North Korea", countryCode: "KP" },
    { countryName: "South Korea", countryCode: "KR" },
    { countryName: "Sri Lanka", countryCode: "LK" },
    { countryName: "Afghanistan", countryCode: "AF" },
    { countryName: "Albania", countryCode: "AL" },
    { countryName: "Algeria", countryCode: "DZ" },
    { countryName: "Argentina", countryCode: "AR" },
    { countryName: "Australia", countryCode: "AU" },
    { countryName: "Austria", countryCode: "AT" },
    { countryName: "Bahrain", countryCode: "BH" },
    { countryName: "Belgium", countryCode: "BE" },
    { countryName: "Brazil", countryCode: "BR" },
    { countryName: "Canada", countryCode: "CA" },
    { countryName: "Chile", countryCode: "CL" },
    { countryName: "China", countryCode: "CN" },
    { countryName: "Colombia", countryCode: "CO" },
    { countryName: "Croatia", countryCode: "HR" },
    { countryName: "Czech Republic", countryCode: "CZ" },
    { countryName: "Denmark", countryCode: "DK" },
    { countryName: "Egypt", countryCode: "EG" },
    { countryName: "Finland", countryCode: "FI" },
    { countryName: "France", countryCode: "FR" },
    { countryName: "Germany", countryCode: "DE" },
    { countryName: "Ghana", countryCode: "GH" },
    { countryName: "Greece", countryCode: "GR" },
    { countryName: "Hong Kong", countryCode: "HK" },
    { countryName: "Hungary", countryCode: "HU" },
    { countryName: "Indonesia", countryCode: "ID" },
    { countryName: "Iran", countryCode: "IR" },
    { countryName: "Iraq", countryCode: "IQ" },
    { countryName: "Ireland", countryCode: "IE" },
    { countryName: "Israel", countryCode: "IL" },
    { countryName: "Italy", countryCode: "IT" },
    { countryName: "Japan", countryCode: "JP" },
    { countryName: "Jordan", countryCode: "JO" },
    { countryName: "Kazakhstan", countryCode: "KZ" },
    { countryName: "Kenya", countryCode: "KE" },
    { countryName: "Kuwait", countryCode: "KW" },
    { countryName: "Lebanon", countryCode: "LB" },
    { countryName: "Libya", countryCode: "LY" },
    { countryName: "Mexico", countryCode: "MX" },
    { countryName: "Morocco", countryCode: "MA" },
    { countryName: "Myanmar", countryCode: "MM" },
    { countryName: "Nepal", countryCode: "NP" },
    { countryName: "Netherlands", countryCode: "NL" },
    { countryName: "New Zealand", countryCode: "NZ" },
    { countryName: "Nigeria", countryCode: "NG" },
    { countryName: "Norway", countryCode: "NO" },
    { countryName: "Oman", countryCode: "OM" },
    { countryName: "Pakistan", countryCode: "PK" },
    { countryName: "Peru", countryCode: "PE" },
    { countryName: "Poland", countryCode: "PL" },
    { countryName: "Portugal", countryCode: "PT" },
    { countryName: "Qatar", countryCode: "QA" },
    { countryName: "Romania", countryCode: "RO" },
    { countryName: "Russia", countryCode: "RU" },
    { countryName: "Saudi Arabia", countryCode: "SA" },
    { countryName: "South Africa", countryCode: "ZA" },
    { countryName: "Spain", countryCode: "ES" },
    { countryName: "Sweden", countryCode: "SE" },
    { countryName: "Switzerland", countryCode: "CH" },
    { countryName: "Taiwan", countryCode: "TW" },
    { countryName: "Thailand", countryCode: "TH" },
    { countryName: "Turkey", countryCode: "TR" },
    { countryName: "Ukraine", countryCode: "UA" },
    { countryName: "United Arab Emirates", countryCode: "AE" },
    { countryName: "United Kingdom", countryCode: "GB" },
    { countryName: "United States", countryCode: "US" },
    { countryName: "Uzbekistan", countryCode: "UZ" },
    { countryName: "Venezuela", countryCode: "VE" },
    { countryName: "Vietnam", countryCode: "VN" },
    { countryName: "Yemen", countryCode: "YE" },
    { countryName: "Zimbabwe", countryCode: "ZW" },
    { countryName: "Angola", countryCode: "AO" },
    { countryName: "Armenia", countryCode: "AM" },
    { countryName: "Azerbaijan", countryCode: "AZ" },
    { countryName: "Belarus", countryCode: "BY" },
    { countryName: "Bolivia", countryCode: "BO" },
    { countryName: "Bulgaria", countryCode: "BG" },
    { countryName: "Cambodia", countryCode: "KH" },
    { countryName: "Cameroon", countryCode: "CM" },
    { countryName: "Congo", countryCode: "CG" },
    { countryName: "Costa Rica", countryCode: "CR" },
    { countryName: "Cuba", countryCode: "CU" },
    { countryName: "Dominican Republic", countryCode: "DO" },
    { countryName: "Ecuador", countryCode: "EC" },
    { countryName: "El Salvador", countryCode: "SV" },
    { countryName: "Ethiopia", countryCode: "ET" },
    { countryName: "Georgia", countryCode: "GE" },
    { countryName: "Guatemala", countryCode: "GT" },
    { countryName: "Haiti", countryCode: "HT" },
    { countryName: "Honduras", countryCode: "HN" },
    { countryName: "Jamaica", countryCode: "JM" },
    { countryName: "Kyrgyzstan", countryCode: "KG" },
    { countryName: "Laos", countryCode: "LA" },
    { countryName: "Latvia", countryCode: "LV" },
    { countryName: "Lithuania", countryCode: "LT" },
    { countryName: "Madagascar", countryCode: "MG" },
    { countryName: "Mali", countryCode: "ML" },
    { countryName: "Mauritius", countryCode: "MU" },
    { countryName: "Mongolia", countryCode: "MN" },
    { countryName: "Mozambique", countryCode: "MZ" },
    { countryName: "Panama", countryCode: "PA" },
    { countryName: "Paraguay", countryCode: "PY" },
    { countryName: "Rwanda", countryCode: "RW" },
    { countryName: "Senegal", countryCode: "SN" },
    { countryName: "Serbia", countryCode: "RS" },
    { countryName: "Slovakia", countryCode: "SK" },
    { countryName: "Slovenia", countryCode: "SI" },
    { countryName: "Sudan", countryCode: "SD" },
    { countryName: "Tajikistan", countryCode: "TJ" },
    { countryName: "Tanzania", countryCode: "TZ" },
    { countryName: "Tunisia", countryCode: "TN" },
    { countryName: "Uganda", countryCode: "UG" },
    { countryName: "Uruguay", countryCode: "UY" },
    { countryName: "Zambia", countryCode: "ZM" }
  ];

  useEffect(() => {
    axios.get("https://api.ipify.org/?format=json")
      .then(response => {
        const userIP = response.data.ip;
        axios.get(`https://api.ipgeolocation.io/ipgeo?apiKey=1d1ccb9fa8c840a5b0ca1a7ebb10a902&ip=${userIP}`)
          .then(response => {
            const country = response.data.country_name;
            console.log("detected country:", country);
            
            // Check if detected country exists in our static list
            const countryExists = countries.find(c => c.countryName === country);
            
            if (countryExists) {
              setMyCountry({
                country: country,
                countryCode: countryExists.countryCode,
              });
              setuserDetails({
                ...userDetails,
                country: countryExists.countryCode,
              });
            } else {
              // If detected country not in list, default to Singapore
              setMyCountry({
                country: "Singapore",
                countryCode: "SG",
              });
              setuserDetails({
                ...userDetails,
                country: "SG",
              });
            }
          })
          .catch(error => {
            console.error("Error fetching geolocation data:", error);
          });
      })
      .catch(error => {
        console.error("Error fetching user's IP address:", error);
      });
  }, []);

  const handleOnChangeCountries = (e) => {
    const selectedCountryCode = e.target.value;
    const selectedCountry = countries.find(country => country.countryCode === selectedCountryCode);
    
    setMyCountry({
      country: selectedCountry ? selectedCountry.countryName : "Singapore",
      countryCode: selectedCountryCode,
    });
    setuserDetails({
      ...userDetails,
      country: selectedCountryCode,
    });
  };

  console.log("selected country:", myCountry.countryCode);

  return (
    <div className="payment-card mt-2">
      <form className="row g-3" onSubmit={handleSubmit}>
        <div className="col-12">
          <label htmlFor="inputEmail4" className="form-label">
            Name as per card
          </label>
          <input required type="name" className="form-control" id="inputEmail4" />
        </div>
        <div className="col-12">
          <label htmlFor="inputEmail4" className="form-label">
            Select your country
          </label>
          <select
            className="form-select"
            aria-label="Default select example"
            value={myCountry.countryCode}
            onChange={handleOnChangeCountries}
          >
            {countries.map((country) => (
              <option key={country.countryCode} value={country.countryCode}>
                {country.countryName}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12">
          <label htmlFor="inputAddress" className="form-label">
            Address
          </label>
          <input
            required
            onChange={(e) => setuserDetails({ ...userDetails, city: e.target.value })}
            type="text"
            className="form-control"
            id="inputAddress"
            placeholder=""
          />
        </div>
        <div className="col-12">
          <label htmlFor="inputAddress" className="form-label">
            Zip/Postal
          </label>
          <input required type="number" className="form-control" id="zipcode" placeholder="" />
        </div>
        <div className="col-12">
          <label htmlFor="inputAddress" className="form-label">
            Card Details
          </label>
          <CardElement options={{ style: cardElementStyles }} />
          {cardError && (
            <p
              style={{
                color: "rgb(231, 31, 31)",
                fontSize: "13px",
                fontWeight: "bold",
                margin: "4px 0 0 0",
              }}
            >
              {cardError}
            </p>
          )}
        </div>

        <hr className="mb-0" />

        <div className="col-12">
          <button type="submit" className="btn btn-primary w-100" disabled={loader}>
            {loader ? "SAVING..." : "SAVE CARD"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PaymentMethodForm;